export default "__VITE_ASSET__CjSm3Cme__"